import { render, staticRenderFns } from "./template-meta-data.vue?vue&type=template&id=3e21c43d"
import script from "./template-meta-data.vue?vue&type=script&lang=js"
export * from "./template-meta-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports